import React, { useEffect, useState, useCallback, useMemo } from "react";
import { AppListing } from "../../components/appListing";
import { campaignsApi } from "../../redux/service/campaigns_service";
import { toast } from "react-toastify";
import { AiFillMessage } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import ShowMessageDialogue from "./showMessageDialogue";
import moment from "moment";

function Campaigns() {
  const [campaignsListingTrigger] =
    campaignsApi.endpoints.getCampaigns.useLazyQuery();
  const [loading, setLoading] = useState(false);
  const [campaignsList, setCampaignsList] = useState([]);
  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  const fetchCampaigns = useCallback(async () => {
    setLoading(true);
    try {
      const response = await campaignsListingTrigger();
      if (response?.data?.data) {
        setCampaignsList(response.data.data);
      } else {
        setCampaignsList([]);
      }
    } catch (error) {
      console.error("Error fetching campaigns", error);
      toast.error("Error fetching campaigns");
      setCampaignsList([]);
    } finally {
      setLoading(false);
    }
  }, [campaignsListingTrigger]);

  useEffect(() => {
    fetchCampaigns();
  }, [fetchCampaigns]);

  const handleShowEmailMessage = useCallback((item, type) => {
    return (
      <div
        className="flex items-center cursor-pointer"
        role="button"
        tabIndex={0}
        onClick={() =>
          setMessage({
            type,
            message: type === "text" ? item.text_message : item.email_body,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setMessage({
              type,
              message: type === "text" ? item.text_message : item.email_body,
            });
          }
        }}
      >
        {type === "text" ? (
          <AiFillMessage color="#0070e5" />
        ) : (
          <MdEmail color="#0070e5" />
        )}
      </div>
    );
  }, []);

  const columns = useMemo(
    () => [
      { title: "Campaign Name", key: "campaign_name" },
      {
        title: "Received on",
        key: "received_on",
        getData: (item) => moment(item?.created).format("MM/DD/YYYY hh:mm A"),
      },
      {
        title: "Text Message",
        key: "text_message",
        getData: (item) => handleShowEmailMessage(item, "text"),
      },
      {
        title: "Email",
        key: "email_body",
        getData: (item) => handleShowEmailMessage(item, "email"),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      {message?.message && (
        <ShowMessageDialogue message={message} setMessage={setMessage} />
      )}
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="flex gap-5 items-center">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Campaigns
          </h3>
        </div>
        <div className="flex-shrink-0">
          <button
            type="button"
            onClick={fetchCampaigns}
            className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Reload
          </button>
        </div>
      </div>
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <AppListing loading={loading} listData={campaignsList} cols={columns} />
      </div>
    </>
  );
}

export default React.memo(Campaigns);
